import { Temporal } from "@js-temporal/polyfill";

export function localDateTimeToEpochMs(localDate: string, localTime: string, timezone: string): number {
  return Temporal.ZonedDateTime.from(`${localDate}T${localTime}[${timezone}]`, {
    disambiguation: "compatible",
  }).epochMilliseconds;
}

/** Apply a relative offset to a wall-clock date/time before resolving its UTC instant. */
export function relativeReminderEpochMs(targetLocalDate: string, localTime: string, offsetMinutes: number, timezone: string): number {
  const shifted = Temporal.PlainDateTime.from(`${targetLocalDate}T${localTime}`).add({ minutes: offsetMinutes });
  return Temporal.ZonedDateTime.from(`${shifted.toString()}[${timezone}]`, { disambiguation: "compatible" }).epochMilliseconds;
}

export function epochMsToLocal(timestamp: number, timezone: string): { localDate: string; localTime: string } {
  const zoned = Temporal.Instant.fromEpochMilliseconds(timestamp).toZonedDateTimeISO(timezone);
  return {
    localDate: zoned.toPlainDate().toString(),
    localTime: zoned.toPlainTime().toString({ smallestUnit: "minute" }),
  };
}

export function addDays(localDate: string, days: number): string {
  return Temporal.PlainDate.from(localDate).add({ days }).toString();
}

export function compareDates(left: string, right: string): number {
  return Temporal.PlainDate.compare(Temporal.PlainDate.from(left), Temporal.PlainDate.from(right));
}

export function datesBetween(start: string, end: string): string[] {
  if (compareDates(start, end) > 0) throw new Error("Horizon start must not be after horizon end.");
  const dates: string[] = [];
  let cursor = Temporal.PlainDate.from(start);
  const final = Temporal.PlainDate.from(end);
  while (Temporal.PlainDate.compare(cursor, final) <= 0) {
    dates.push(cursor.toString());
    cursor = cursor.add({ days: 1 });
  }
  return dates;
}

export function isDateInRange(date: string, start?: string, end?: string): boolean {
  return (!start || compareDates(date, start) >= 0) && (!end || compareDates(date, end) <= 0);
}
